export default __webpack_public_path__ + "static/media/02-1.c7e3c9d8.jpg";